import React from 'react'
import Navbar from '../../components/agent/common/Navbar'
import MainDashboard from '../../components/agent/dashboard/MainDashboard'

const AgentDashboard = () => {
  return (
 <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainDashboard/>
      </main>
    </div> 
     )
}

export default AgentDashboard